export default {
  title: 'Iniciar a sua subscrição',
  title_confirm: 'Confirme o seu plano',
  step: 'Passo {{current}} de {{total}}',
  subtitle: '{{name}} · 1 localização',
  trial_badge: '{{days}} dias grátis',
  trial_headline: 'Primeiros {{days}} dias grátis',
  then_price: 'Depois {{price}} / mês por localização · imposto aplicável incl.',
  price_per_month: '{{price}} / mês',
  price_terms: 'Por localização, faturado mensalmente · imposto aplicável incl.',
  tier_upsell:
    'Escale para {{threshold}}+ localizações ativas e o preço para todas as suas localizações desce para {{price}} / mês por localização — automaticamente.',
  tier_active: 'Taxa de volume — {{threshold}}+ localizações ativas',
  due_today: 'A pagar hoje',
  from_date: 'A partir de {{date}}',
  no_charge_today: 'Não será cobrado hoje.',
  no_charge_until: 'Não será cobrado hoje. Cancele até {{date}} e não paga nada.',
  active: '{{plan}} está ativo para este restaurante.',
  active_with_trial: '{{plan}} está ativo para este restaurante, gratuito até {{date}}.',
  terms:
    'Concordo com os <a href="{{terms_url}}" target="_blank" rel="noreferrer">Termos da Plataforma de Parceiros FoodAmigos</a>, incluindo ativação, cancelamento e reembolsos.',
  error: 'Não foi possível concluir a compra. Por favor, tente novamente.',
  loading: 'A verificar o plano deste restaurante…',
  load_error: 'Não foi possível verificar o plano deste restaurante.',
  unavailable: 'Este produto não está disponível para este restaurante. Contacte o seu gestor de conta FoodAmigos.',
  products: {
    online_ordering: {
      features: {
        ordering: {
          title: 'Pedidos online',
          description: 'Pedidos diretos no site próprio do restaurante',
        },
        reservations: {
          title: 'Reservas de mesa',
          description: 'Os clientes reservam mesa diretamente online',
        },
        marketing: {
          title: 'Suite de Marketing',
          description:
            'Criador de Ofertas, programa de pontos de fidelidade e respostas com IA às avaliações do Google',
        },
        pricing: {
          title: '0% de comissão, sem taxa de instalação',
          description: 'Uma licença por localização, faturada mensalmente',
        },
      },
    },
    mobile_app: {
      features: {
        app: {
          title: 'A aplicação própria do restaurante',
          description: 'Na App Store e no Google Play',
        },
        engagement: {
          title: 'Notificações push e fidelização',
          description: 'Traga os clientes de volta com ofertas e pontos',
        },
        ordering: {
          title: 'Pedidos com 0% de comissão',
          description: 'Pedidos diretos a partir da aplicação',
        },
        apple: {
          title: 'Conta de programador Apple necessária',
          description: '$99/ano, pagos à Apple, na entidade legal do restaurante',
        },
      },
    },
    ai_website: {
      title: 'Subscrição do Criador de Sites',
      subtitle_domain: 'Coloque o site de {{name}} online em {{domain}}',
      features: {
        domain: {
          title: 'O seu site, online no seu próprio domínio',
          description: 'O site próprio do restaurante',
        },
        ai: {
          title: 'Criado e atualizado com IA',
          description: 'Crie páginas, textos e imagens para o restaurante em minutos',
        },
        ordering: {
          title: 'Pedidos e reservas incluídos',
          description: 'Os clientes pedem e reservam mesa diretamente a partir do site',
        },
        pricing: {
          title: 'Sem taxa de instalação',
          description: 'Uma licença por localização, faturada mensalmente',
        },
      },
    },
    storefront: {
      title: 'Subscrição do Criador de Sites',
      subtitle_domain: 'Coloque o site de {{name}} online em {{domain}}',
      features: {
        domain: {
          title: 'O seu site, online no seu próprio domínio',
          description: 'O site próprio do restaurante',
        },
        ai: {
          title: 'Criado e atualizado com IA',
          description: 'Crie páginas, textos e imagens para o restaurante em minutos',
        },
        ordering: {
          title: 'Pedidos e reservas incluídos',
          description: 'Os clientes pedem e reservam mesa diretamente a partir do site',
        },
        pricing: {
          title: 'Sem taxa de instalação',
          description: 'Uma licença por localização, faturada mensalmente',
        },
      },
    },
  },
  payment_method: {
    label: 'O seu método de pagamento de parceiro',
    on_file: 'Cartão registado',
    pending_title: 'A confirmar o seu método de pagamento',
    pending: 'O Stripe ainda está a confirmar o cartão que acabou de adicionar. Isto pode demorar um minuto.',
    still_pending: 'Ainda não. Espere um pouco e verifique novamente.',
    error: 'Não foi possível abrir o formulário de pagamento. Tente novamente.',
  },
  buttons: {
    close: 'Fechar',
    continue_to_payment: 'Continuar para o pagamento',
    start_trial: 'Iniciar teste gratuito de {{days}} dias',
    subscribe: 'Iniciar subscrição',
    continue: 'Continuar',
    change: 'Alterar',
    retry: 'Tentar novamente',
    check_again: 'Verificar novamente',
    add_again: 'Adicionar cartão novamente',
  },
};
